/*
  G36 · APARICIÓN AL HACER SCROLL
  Los elementos con [data-g36-fade] suben y aparecen la primera vez que
  entran en pantalla (estilos en assets/g36-base.css). Escalonar con
  style="--i: n". Animación corta (0.45 s) que arranca antes de que el
  elemento llegue a la pantalla; lo que ya se ve al cargar aparece de una vez. Si no hay IntersectionObserver o el usuario pidió
  "reducir movimiento", no se hace nada y todo se ve desde el principio.
  También detecta elementos añadidos después (p. ej. "Ver más").
*/
(function () {
  if (window.G36Motion) return;
  if (!('IntersectionObserver' in window)) return;
  if (!window.matchMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELECTOR = '[data-g36-fade]:not(.is-visible)';
  var root = document.documentElement;

  var reveal = function (el) {
    el.classList.add('is-visible');
    io.unobserve(el);
  };

  // Se dispara antes de que el elemento entre (25 % de pantalla por debajo) y también para
  // lo que ya quedó arriba al bajar muy rápido: nada se queda negro esperando.
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var rootBottom = entry.rootBounds ? entry.rootBounds.bottom : window.innerHeight;
        if (entry.isIntersecting || entry.boundingClientRect.top < rootBottom) reveal(entry.target);
      });
    },
    { threshold: 0, rootMargin: '0px 0px 25% 0px' }
  );

  // Lo que ya está en pantalla (o casi) al cargar se muestra de una vez, sin esperar al observador
  var nearViewport = function (el) {
    var rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight * 1.25 && (rect.bottom > 0 || rect.top < 0);
  };

  var watch = function (scope) {
    if (!scope || !scope.querySelectorAll) return;
    var list = [];
    if (scope.matches && scope.matches(SELECTOR)) list.push(scope);
    scope.querySelectorAll(SELECTOR).forEach(function (el) {
      list.push(el);
    });
    list.forEach(function (el) {
      if (nearViewport(el)) el.classList.add('is-visible');
      else io.observe(el);
    });
  };

  root.classList.add('g36-motion');
  window.G36Motion = { watch: watch };

  var start = function () {
    watch(document);

    // Solo mira nodos nuevos que contengan el atributo (barato: sin recorrer todo el DOM)
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) watch(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
